import { error as bugerror } from "./Bugs.ts";
import { API_BASE_URL, USE_FAKE_ACCOUNT, USE_FAKE_SUB } from "./Vars.js";
import { getRandomInt } from "./Util.js";

class LoginnedAccount {
  constructor(displayname, first_name, last_name, avatar_url) {
    this.first_name = first_name;
    this.last_name = last_name;
    this.avatar_url = avatar_url
    this.displayname = displayname
  }
}

class SubStatus {
  constructor(is_sub, text, days_remains, price_rub) {
    this.is_sub = is_sub;
    this.text = text;
    this.days_remains = days_remains;
    this.price_rub = price_rub;
  }
}

class CreatedPaymentInfo {
  constructor(is_success, confirmation_url, is_already_sub) {
    this.is_success = is_success;
    this.confirmation_url = confirmation_url;
    this.is_already_sub = is_already_sub;
  }
}

export const NO_AUTH = new LoginnedAccount()

export async function requestLoginedAccount() {
  // Простая проверка admin авторизации
  if (localStorage.getItem('admin_logged_in') === 'true') {
    return new LoginnedAccount("Администратор", "Админ", "Системы", "https://avatars.githubusercontent.com/u/1?s=60&v=4");
  }
  
  if (USE_FAKE_ACCOUNT) {
    let r = getRandomInt(0, 100000)
    return new LoginnedAccount("Имя Фамильечивя", "Имя", "Фамильевича", "https://avatars.githubusercontent.com/u/"+r+"?s=60&v=4")
  }
  try {
    const response = await fetch(API_BASE_URL + 'myaccount');

    if (!response.ok) {
      bugerror("not ok request myaccount", response.status)
      return NO_AUTH;
    }

    const data = await response.json();
    if (data.noauth) {
      return NO_AUTH;
    }
    if (data.displayname && data.first_name && data.last_name && data.avatar_url) {
      return new LoginnedAccount(data.displayname, data.first_name, data.last_name, data.avatar_url);
    } else {
      bugerror("request account no valid data");
      return NO_AUTH;
    }

  } catch (error) {
    bugerror("request account", error);
    return NO_AUTH;
  }
}

export async function requestSubStatus() {
  if (USE_FAKE_SUB) {
    return new SubStatus(false, "Нету", 0, 179);
  }
  try {
    const response = await fetch(API_BASE_URL + 'sub/status');

    if (!response.ok) {
      bugerror("not ok request sub/status", response.status)
      return null;
    }

    const data = await response.json();
    if (data.noauth) {
      return NO_AUTH;
    }
    return new SubStatus(data.is_sub == true, data.text, data.days_remains, data.price_rub);

  } catch (error) {
    bugerror("request sub/status", error);
    return null;
  }
}

export async function requestCreatePayment(customerEmail) {
  try {
    const params = new URLSearchParams();
    params.append('customer_email', customerEmail);
    const finalUrl = `${API_BASE_URL}sub/pay_v1?${params.toString()}`;
    const response = await fetch(finalUrl);

    if (!response.ok) {
      bugerror("not ok request sub/pay_v1", response.status)
      return null;
    }

    const data = await response.json();
    if (data) {
      return new CreatedPaymentInfo(data.is_success, data.confirmation_url, data.is_already_sub);
    } else {
      bugerror("request sub/pay_v1 no valid data");
      return null;
    }

  } catch (error) {
    bugerror("request sub/pay_v1", error);
    return null;
  }
}

export async function logout() {
  // Проверяем, является ли пользователь admin
  if (localStorage.getItem('admin_logged_in') === 'true') {
    localStorage.removeItem('admin_logged_in');
    window.location.reload();
    return;
  }
  
  try {
    const response = await fetch(API_BASE_URL + 'logout', { method: 'POST' });
    if (response.ok) {
      window.location.reload();
    } else {
      bugerror("logout", new Error(`Logout failed with status: ${response.status}`));
    }
  } catch (error) {
    bugerror("logout", error);
  }
}

